'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var React = require('react');
var Button = require('react-bootstrap/Button');
var fa = require('react-icons/fa');
var messageDisplayer = require('@tunz/message-displayer');
var HttpClient = require('@tunz/http');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var HttpClient__default = /*#__PURE__*/_interopDefaultLegacy(HttpClient);

/**
 * Allows downloading a file and correctly handling HTTP response codes
 */
class DownloadElement extends React.Component {
    constructor(props) {
        super(props);
        this.startDownloadFile = () => _tslib.__awaiter(this, void 0, void 0, function* () {
            const { url } = this.props;
            try {
                this.setState({ loading: true });
                const response = yield HttpClient__default["default"].get(url, { responseType: 'blob' });
                this.setState((s) => (Object.assign(Object.assign({}, s), { responseFileName: DownloadElement.getResponseFileName(response.headers) })));
                this.handleBlob(new Blob([response.data]));
            }
            catch (e) {
                messageDisplayer.displayError(e);
            }
            finally {
                this.setState({ loading: false });
            }
        });
        this.handleBlob = (blob) => {
            const reader = new FileReader();
            reader.onload = this.downloadSucceeded;
            reader.readAsDataURL(blob);
        };
        this.downloadSucceeded = (progressEvent) => {
            const { responseFileName } = this.state;
            const { target } = progressEvent;
            const { fileName } = this.props;
            if (target instanceof FileReader) {
                const { result } = target;
                if (typeof result === 'string') {
                    // Construct the 'a' element
                    const link = document.createElement('a');
                    link.download = fileName || responseFileName || 'downloadedFile';
                    link.target = '_blank';
                    // Construct the URI
                    link.href = result;
                    document.body.appendChild(link);
                    // Trigger the download
                    link.click();
                    // Cleanup the DOM
                    document.body.removeChild(link);
                }
            }
        };
        this.state = { loading: false };
    }
    render() {
        const { loading } = this.state;
        const { variant, text, size, inactive } = this.props;
        let currentText = text;
        if (loading && text && text.length > 0 && !inactive) {
            currentText = 'Downloading...';
        }
        if (text && text.length > 0 && inactive && !loading) {
            currentText = 'Loading...';
        }
        const getBootstrapSize = () => {
            switch (size) {
                case 'small':
                    return 'sm';
                case 'large':
                    return 'lg';
                default:
                    return undefined;
            }
        };
        return (React__default["default"].createElement(Button__default["default"], { variant: variant, size: getBootstrapSize(), onClick: this.startDownloadFile, title: "Download File", disabled: loading || inactive },
            React__default["default"].createElement(fa.FaRegArrowAltCircleDown, null),
            currentText && (currentText === null || currentText === void 0 ? void 0 : currentText.length) > 0 && React__default["default"].createElement(React__default["default"].Fragment, null,
                " \u00A0 ",
                currentText)));
    }
}
DownloadElement.defaultProps = {
    fileName: undefined,
    variant: 'link',
    text: '',
    size: 'small',
    inactive: false,
};
DownloadElement.getResponseFileName = (headers) => {
    const contentDisposition = headers['content-disposition'];
    if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch) {
            return fileNameMatch[1];
        }
    }
    return undefined;
};

exports["default"] = DownloadElement;
